import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import MainLayout from '../layout/MainLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/DashboardView.vue')
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('../views/BannerView.vue')
      },
      {
        path: 'region',
        name: 'Region',
        component: () => import('../views/RegionView.vue')
      },
      {
        path: 'paper',
        name: 'Paper',
        component: () => import('../views/ExamPaperView.vue')
      },
      {
        path: 'paper/:paperId/questions',
        name: 'QuestionView',
        component: () => import('../views/QuestionView.vue')
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('../views/UserView.vue')
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('../views/AdminView.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('../views/ProfileView.vue')
      },
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('../views/CouponView.vue')
      },
      {
        path: 'consumption',
        name: 'Consumption',
        component: () => import('../views/ConsumptionView.vue')
      },
      {
        path: 'invitation',
        name: 'Invitation',
        component: () => import('../views/InvitationView.vue')
      },
      {
        path: 'standard-word',
        name: 'StandardWord',
        component: () => import('../views/StandardWordView.vue')
      },
      {
        path: 'my-page-option',
        name: 'MyPageOption',
        component: () => import('../views/MyPageOptionView.vue')
      },
      {
        path: 'prompt-config',
        name: 'PromptConfig',
        component: () => import('../views/PromptConfigView.vue')
      },
      {
        path: 'vip-package',
        name: 'VipPackage',
        component: () => import('../views/VipPackageView.vue')
      },
      {
        path: 'single-question',
        name: 'SingleQuestion',
        component: () => import('../views/SingleQuestionView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to: any, from: any, next: any) => {
  const token = localStorage.getItem('admin_token')
  
  if (to.path === '/login') {
    if (token) {
      next('/dashboard')
    } else {
      next()
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
